import { Injectable } from '@angular/core';
import { ICashRegisterVendorInterface } from '../../cash-register-vendor.interface';
import { CashRegisterEntity } from '../../../../../models/entity/cash-register/cash-register-entity';
import { CashRegisterPaymentCancelLocalResponse } from '../../../../../models/rest/cash-register/cancel/cash-register-payment-cancel-local-response';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalAppService } from '../../../../app/local-app.service';
import { firstValueFrom, Observable } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { CashRegisterCreateBasketResponse } from '../../../../../models/rest/cash-register/sale/cash-register-create-basket-response';
import { AuthService } from '../../../../../services/auth.service';
import { CashRegisterXReportLocalResponse } from '../../../../../models/rest/cash-register/report/x-report/cash-register-x-report-local-response';
import { CashRegisterCloseShiftLocalResponse } from '../../../../../models/rest/cash-register/close_shift/cash-register-close-shift-local-response';
import { CashRegisterZReportBulkLocalResponse } from '../../../../../models/rest/cash-register/report/z-report/cash-register-z-report-bulk-local-response';
import { CashRegisterOpenShiftLocalResponse } from '../../../../../models/rest/cash-register/open_shift/cash-register-open-shift-local-response';
import { CashRegisterControlTapeLocalResponse } from '../../../../../models/rest/cash-register/control-tape/cash-register-control-tape-local-response';
import { CashRegisterPairLocalResponse } from '../../../../../models/rest/cash-register/pair/cash-register-pair-local-response';
import { StringUtils } from '../../../../../utils/string.utils';
@Injectable({
  providedIn: 'root'
})
export class SmartOneService implements ICashRegisterVendorInterface {
  private baseUrl: string = '';
  appName = "SMARTONE";
  timeout: 30;

  constructor(private http: HttpClient,
    private authService: AuthService,
    private localAppService: LocalAppService) { }
  pair(cashRegister: CashRegisterEntity, data: CashRegisterPairLocalResponse) {
    throw new Error('Method not implemented.');
  }

  controlTape(cashRegister: CashRegisterEntity, data: CashRegisterControlTapeLocalResponse) {
    throw new Error('Method not implemented.');
  }


  getDeviceInfo(cashRegister: CashRegisterEntity) {
    throw new Error('Method not implemented.');
  }


  setToken(cashRegister: CashRegisterEntity, token?: string) {
  }

  getToken(data: CashRegisterEntity) {
    return;
  }

  isLoggedIn(data: CashRegisterEntity): boolean {
    return true;
  }
  setBaseUrl(data: CashRegisterEntity) {
    if (StringUtils.isEmpty(data.apiUrl)) {
      throw new Error("Yazar kasa ip adresi boş olamaz");
    }
    this.baseUrl = data.apiUrl!;

    if (!this.baseUrl.includes(":"))
      this.baseUrl = this.baseUrl + ":8008";

    if (!this.baseUrl.startsWith("http://")) {
      this.baseUrl = "http://" + this.baseUrl;
    }

  }

  login(cashRegister: CashRegisterEntity) {
    return;
  }

  async createSale(cashRegister: CashRegisterEntity, request: CashRegisterCreateBasketResponse) {
    this.setBaseUrl(cashRegister);

    // Orijinal JSON body
    const finalBody = this.getFinalBody(cashRegister, request.data);


    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl + (request.isPrepayment ? "/prepay" : "/sale"), finalBody, { 'Content-Type': 'text/plain' }, this.timeout)
      )
    );
  }

  cancelSale(cashRegister: CashRegisterEntity, request: CashRegisterPaymentCancelLocalResponse) {
    this.setBaseUrl(cashRegister);

    // Orijinal JSON body
    const finalBody = this.getFinalBody(cashRegister, request.data);

    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl + "/rollback", finalBody, { 'Content-Type': 'text/plain' }, this.timeout)
      )
    );
  }


  async openShift(cashRegister: CashRegisterEntity, request: CashRegisterOpenShiftLocalResponse) {

    this.setBaseUrl(cashRegister);

    // Orijinal JSON body
    const finalBody = this.getFinalBody(cashRegister, request.data);

    return await this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl + "/open_shift", finalBody, { 'Content-Type': 'text/plain' }, this.timeout)
      )
    );

  }

  async closeShift(cashRegister: CashRegisterEntity, request: CashRegisterCloseShiftLocalResponse) {
    this.setBaseUrl(cashRegister);

    // Orijinal JSON body
    const finalBody = this.getFinalBody(cashRegister, request.data);

    return await this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl + "/close_shift", finalBody, { 'Content-Type': 'text/plain' }, this.timeout)
      )
    );

  }

  async getXReport(cashRegister: CashRegisterEntity, request: CashRegisterXReportLocalResponse) {
    this.setBaseUrl(cashRegister);

    // Orijinal JSON body
    const finalBody = this.getFinalBody(cashRegister, request.data);

    return await this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl + "/x_report", finalBody, { 'Content-Type': 'text/plain' }, this.timeout)
      )
    );
  }

  getZReport(cashRegister: CashRegisterEntity, data: CashRegisterZReportBulkLocalResponse) {
    throw new Error('Method not implemented.');
  }

  private getFinalBody(cashRegister: CashRegisterEntity, request: any,) {
    const body = request;

    // 1. Body'yi JSON formatına çevir ve Base64 ile kodla
    const base64Body = btoa(body);

    // 2. SHA1 hash hesapla (base64Body + merchantId)
    const dataToSign = base64Body + cashRegister.merchantKey;
    const sha1Hash = CryptoJS.SHA1(dataToSign).toString();

    // 3. Hash'i tekrar Base64'e çevir
    const base64Hash = btoa(sha1Hash);

    // 4. URL encode işlemi
    const finalBody = 'data=' +
      encodeURIComponent(base64Body) +
      '&sign=' +
      encodeURIComponent(base64Hash);
    return finalBody;
  }

  private async handleRequest(
    cashRegister: CashRegisterEntity,
    request: any,
    action: () => Promise<any>
  ) {

    let response = await action();

    if (!StringUtils.isJsonString(response.data))
      throw new Error(response.data ?? "Servisten boş cevap geldi");
    let res = JSON.parse(response.data);

    return res;
  }

}
